/**
 * @author MrZenW
 * @email MrZenW@Gmail.com, https://MrZenW.com
 * @create date 2021-11-29 13:10:52
 * @modify date 2021-11-29 13:11:05
 * @desc [description]
 */

exports.RoomContext = require('react').createContext({});
